let latestOffset = 0;

const ourStorySwiperPrevBtnClass = "our-story-prev-btn";
const ourStorySwiperNextBtnClass = "our-story-next-btn";
const ourStorySwiperPaginationClass = "our-story-pagination";

const slideYearDivs = Array.from(document.getElementsByClassName("our-story-year"));
const slideTitleDivs = Array.from(document.getElementsByClassName("our-story-title"));
const slideDescDivs = Array.from(document.getElementsByClassName("our-story-desc"));
const slideNavDivs = Array.from(document.getElementsByClassName("our-story-nav-btn-wrapper"));

const ourStorySwiper = new Swiper(".our-story-swiper", {
  // Optional parameters
  resistanceRatio:0,
  parallax: true,
  direction: "horizontal",
  shortSwipes: true,
  simulateTouch: true,
  slideToClickedSlide: false,
  loop: false,
  speed: 600,
  autoHeight: true,
  effect: "slide",
  allowSlidePrev: true,
  allowSlideNext: true,
  allowTouchMove: true,
  // Navigation arrows
  navigation: {
    prevEl: "." + ourStorySwiperPrevBtnClass,
    nextEl: "." + ourStorySwiperNextBtnClass,
  },
  pagination: {
    el: "." + ourStorySwiperPaginationClass,
    clickable: true,
    renderBullet: function (idx, className) {
      return `<span class="${className}">${Array.from(document.querySelectorAll(".our-story-swiper .swiper-slide"))[idx].querySelector(".our-story-year").innerText}</span>`;
    },
  },
  on: {
    slideChange: (swiper) => {
      swiper.pagination.render();
      swiper.pagination.update();
      updatePaginationPosition();
    },
  },
});

const ourTechnologiesPrevBtn = "our-technologies-prev-btn";
const ourTechnologiesNextBtn = "our-technologies-next-btn";
const ourTechnologiesSwiperScrollbarClass = "our-technologies-scrollbar";

const ourTechnologiesSwiper = new Swiper(".our-technologies-swiper", {
  // Optional parameters
  resistanceRatio:0,
  parallax: true,
  direction: "horizontal",
  shortSwipes: true,
  simulateTouch: true,
  slideToClickedSlide: false,
  loop: false,
  speed: 600,
  autoHeight: true,
  effect: "slide",
  allowSlidePrev: true,
  allowSlideNext: true,
  allowTouchMove: true,
  slidesPerView: 1,
  // Navigation arrows
  navigation: {
    prevEl: "." + ourTechnologiesPrevBtn,
    nextEl: "." + ourTechnologiesNextBtn,
  },
  scrollbar: {
        el: "." + ourTechnologiesSwiperScrollbarClass,
        hide: false,
  },
  on: {
  },
  breakpoints: {
    1300:{
      slidesPerView: 5
    },
    1100:{
      slidesPerView: 4
    },
    900:{
      slidesPerView: 3
    },
    700:{
      slidesPerView: 2
    }
  },
});

const ourStorySwiperEl = ourStorySwiper.el;
const ourStorySwiperPrevBtnEl = ourStorySwiperEl.querySelector("." + ourStorySwiperPrevBtnClass);
const ourStorySwiperNextBtnEl = ourStorySwiperEl.querySelector("." + ourStorySwiperNextBtnClass);

const paginationWrapper = ourStorySwiperEl.querySelector("." + ourStorySwiperPaginationClass);

window.addEventListener("resize", windowResized);

let lastResize = null;
//Run it once on load
windowResized();

function windowResized(){
  ourStorySwiper.updateAutoHeight();
  updatePaginationPosition();
    
  const currentWidth = window.innerWidth;
    
  //If this resize just broke through into the mobile breakpoint (not triggered if it was already in mobile)
  if (currentWidth <= mobileWidthBreakpoint && (!lastResize || lastResize > mobileWidthBreakpoint)){
        slideYearDivs.forEach(div => {
      div.dataset.swiperParallaxY = parallaxYearMovMobile;
      div.dataset.swiperParallaxDuration = parallaxDurationMobile;
      div.dataset.swiperParallaxOpacity = inactiveSlideOpacityMobile;
    });
    slideTitleDivs.forEach(div => {
      div.dataset.swiperParallaxY = parallaxTitleMovMobile;
      div.dataset.swiperParallaxDuration = parallaxDurationMobile;
      div.dataset.swiperParallaxOpacity = inactiveSlideOpacityMobile;
    });
    slideDescDivs.forEach(div => {
      div.dataset.swiperParallaxY = parallaxDescMovMobile;
      div.dataset.swiperParallaxDuration = parallaxDurationMobile;
      div.dataset.swiperParallaxOpacity = inactiveSlideOpacityMobile;
    });
    slideNavDivs.forEach(div => {
      div.dataset.swiperParallaxY = parallaxNavMovMobile;
      div.dataset.swiperParallaxDuration = parallaxDurationMobile;
      div.dataset.swiperParallaxOpacity = inactiveSlideOpacityMobile;
    });
  }
  //If this resize just broke through into the desktop breakpoint (not triggered if it was already in desktop)
  else if (currentWidth > mobileWidthBreakpoint && (!lastResize || lastResize <= mobileWidthBreakpoint)){
    slideYearDivs.forEach(div => {
      div.dataset.swiperParallaxY = parallaxYearMov;
      div.dataset.swiperParallaxDuration = parallaxDuration;
      div.dataset.swiperParallaxOpacity = inactiveSlideOpacity;
    });
    slideTitleDivs.forEach(div => {
      div.dataset.swiperParallaxY = parallaxTitleMov;
      div.dataset.swiperParallaxDuration = parallaxDuration;
      div.dataset.swiperParallaxOpacity = inactiveSlideOpacity;
    });
    slideDescDivs.forEach(div => {
      div.dataset.swiperParallaxY = parallaxDescMov;
      div.dataset.swiperParallaxDuration = parallaxDuration;
      div.dataset.swiperParallaxOpacity = inactiveSlideOpacity;
    });
    slideNavDivs.forEach(div => {
      div.dataset.swiperParallaxY = parallaxNavMov;
      div.dataset.swiperParallaxDuration = parallaxDuration;
      div.dataset.swiperParallaxOpacity = inactiveSlideOpacity;
    });
  }

  lastResize = currentWidth;
}

function updatePaginationPosition(){
  const offsetPadding = 16;
  if (isOverflowingX(paginationWrapper)){
    const allPaginationEls = Array.from(paginationWrapper.querySelectorAll(".swiper-pagination-bullet"));
    const currentPaginationEl = paginationWrapper.querySelector(".swiper-pagination-bullet-active");
    const currentPaginationAdjustedOffsetLeft = currentPaginationEl.offsetLeft - latestOffset;
    
    const halfPointPaginationWrapper = paginationWrapper.clientWidth/2;
    //If the current pagination element is to the right of the pagination wrapper
    if (halfPointPaginationWrapper < currentPaginationAdjustedOffsetLeft){
      //If the last pagination element is not currently visible
      const lastPaginationEl = allPaginationEls.at(-1);
      if(!elIsVisible(lastPaginationEl)){
        const lastPaginationAdjustedOffsetLeft = lastPaginationEl.offsetLeft - latestOffset;
        
        const offsetCenterCurrent = (currentPaginationAdjustedOffsetLeft - halfPointPaginationWrapper) + currentPaginationEl.clientWidth - (currentPaginationEl.clientWidth/2);
        const offsetRightMostPaginationEl = lastPaginationAdjustedOffsetLeft - paginationWrapper.clientWidth + lastPaginationEl.clientWidth + offsetPadding;
        
        const offset = latestOffset + Math.min(offsetCenterCurrent,offsetRightMostPaginationEl);
        paginationWrapper.style.setProperty('left', `calc(50% - ${offset}px)`, 'important');
        latestOffset = offset;
      }
    }
    else{
      //If the first pagination element is not currently visible
      const firstPaginationEl = allPaginationEls[0];
      if(!elIsVisible(firstPaginationEl)){
        const firstPaginationAdjustedOffsetLeft = firstPaginationEl.offsetLeft - latestOffset;
        
        const offsetCenterCurrent = halfPointPaginationWrapper - (currentPaginationAdjustedOffsetLeft + currentPaginationEl.clientWidth) + (currentPaginationEl.clientWidth/2);
        
        let offset = latestOffset - offsetCenterCurrent;
        if (offset < 0) offset = 0;
        console.log(offset)
        paginationWrapper.style.setProperty('left', `calc(50% - ${offset}px)`, 'important');
        latestOffset = offset;
      }
    }
  }
  else{
    latestOffset = 0;
     paginationWrapper.style.setProperty('left', `calc(50%)`, 'important');
  }
}

function elIsVisible(el) {
  const rect = el.getBoundingClientRect();
  const viewWidth = Math.max(document.documentElement.clientWidth, window.innerWidth);
  return !(rect.left < 0 || rect.right - viewWidth >= 0);
}

function isOverflowingX (el) {return el.scrollWidth != Math.max(el.offsetWidth, el.clientWidth)}